import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=32fe3c10&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=ts&"
export * from "./exchange.vue?vue&type=script&lang=ts&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=32fe3c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe3c10",
  null
  
)

export default component.exports